module.exports = __webpack_public_path__ + "img/Business Team Advantages@2x.700b8a79.png";